import { Bell, BellOff, Volume2, VolumeX } from 'lucide-react';
import { Button } from '@makanly/ui-kit';
import type { NotificationSettings } from '../types';

interface NotificationToggleProps {
  settings: NotificationSettings;
  onToggleEnabled: () => void;
  onToggleSound: () => void;
  onRequestPermission: () => void;
}

export function NotificationToggle({
  settings,
  onToggleEnabled,
  onToggleSound,
  onRequestPermission,
}: NotificationToggleProps) {
  const { enabled, soundEnabled, permission } = settings;

  const needsPermission = permission === 'default';
  const permissionDenied = permission === 'denied';

  return (
    <div className="flex items-center gap-2">
      {/* Sound Toggle */}
      <Button
        variant="outline"
        size="sm"
        onClick={onToggleSound}
        className={`
          px-3 py-1.5 h-auto
          ${soundEnabled ? 'text-text-primary' : 'text-text-secondary'}
        `}
        title={soundEnabled ? 'Sound enabled' : 'Sound disabled'}
      >
        {soundEnabled ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />}
      </Button>

      {/* Notification Toggle */}
      {needsPermission ? (
        <Button
          variant="outline"
          size="sm"
          onClick={onRequestPermission}
          className="px-3 py-1.5 h-auto gap-2"
        >
          <Bell className="w-4 h-4" />
          <span className="text-sm">Enable Alerts</span>
        </Button>
      ) : permissionDenied ? (
        <Button
          variant="outline"
          size="sm"
          disabled
          className="px-3 py-1.5 h-auto gap-2 opacity-50"
          title="Notifications blocked by browser"
        >
          <BellOff className="w-4 h-4" />
          <span className="text-sm">Blocked</span>
        </Button>
      ) : (
        <Button
          variant="outline"
          size="sm"
          onClick={onToggleEnabled}
          className={`
            px-3 py-1.5 h-auto gap-2
            ${enabled ? 'text-text-primary' : 'text-text-secondary'}
          `}
        >
          {enabled ? (
            <>
              <Bell className="w-4 h-4" />
              <span className="text-sm">Alerts On</span>
            </>
          ) : (
            <>
              <BellOff className="w-4 h-4" />
              <span className="text-sm">Alerts Off</span>
            </>
          )}
        </Button>
      )}
    </div>
  );
}
